import { Component, inject, signal, OnInit, DestroyRef, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { WeatherService } from '../../service/weather.service';
import { WeatherForecastDetailsResponse, WeatherList } from '../../models/forecast-details';
import { CommonModule } from '@angular/common';
import { CloseIconComponent } from '../icons/close-icon.component';
import { BaseComponent } from '../../../base/components/base.component';
import { ClickableDirective } from '../../directives/clickable.directive';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';


@Component({
    selector: 'app-weather-forecast',
    imports: [
      MatSidenavModule,
      MatFormFieldModule,
      MatSelectModule,
      MatButtonModule,
      CommonModule,
      CloseIconComponent,
      ClickableDirective
    ],
    templateUrl: './weather-forecast.component.html',
    styleUrl: './weather-forecast.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WeatherForecastComponent extends BaseComponent implements OnInit {
  private readonly weatherService = inject(WeatherService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly cdr = inject(ChangeDetectorRef);
  
  isOpen = signal(false);
  weatherData = signal<Array<WeatherList & { iconUrl: string }>>([]);
  iconUrl = signal('');

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.fetchWeatherForecastData();
  }

  private fetchWeatherForecastData(): void {
    this.weatherService
      .getForecast(28.70406, 77.102493)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (data: WeatherForecastDetailsResponse) => {
          const mappedData = data.list.map((item) => ({
            ...item,
            iconUrl: `https://openweathermap.org/img/wn/${item.weather[0].icon}@2x.png`,
          }));
          this.weatherData.set(mappedData);
          this.cdr.detectChanges();
        },
        error: (err) => {
          this.logger.error('WeatherForecast: API Error:', err);
        },
      });
  }

  toggle(): void {
    this.isOpen.update((val) => !val);
  }
}
